import { useEffect, useRef } from "react";
import { useProject, useProjectActions } from "stores/project";

export const useRestoreProject = () => {
  const project = useProject();
  const projectIdRef = useRef(project?.id);
  const projectNameRef = useRef(project?.title);
  const { set: setProject } = useProjectActions();

  useEffect(() => {
    const url = new URL(window.location.href);
    if (projectIdRef.current && projectNameRef.current) {
      url.searchParams.set("originalProjectId", projectIdRef.current);
      url.searchParams.set("originalProjectName", projectNameRef.current);
      window.history.pushState({}, "", url.toString());
    }

    return () => {
      const newUrl = new URL(window.location.href);
      const originalProjectId = newUrl.searchParams.get("originalProjectId");
      const originalProjectName = newUrl.searchParams.get(
        "originalProjectName",
      );
      if (originalProjectId && originalProjectName) {
        newUrl.searchParams.delete("originalProjectName");
      }
      if (originalProjectId) {
        newUrl.searchParams.delete("originalProjectId");
      }
      window.history.pushState({}, "", newUrl.toString());
      if (originalProjectId) {
        setProject(originalProjectId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
